import { inputWithOptionsDriverFactory } from '../InputWithOptions/InputWithOptions.driver';
import { deprecationTestkitLog } from '../utils/deprecationTestkitLog';

const autoCompleteDriverFactory = args => {
  deprecationTestkitLog(
    'autoCompleteTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the AutoCompleteTestkit unidriver testkit instead.',
  );
  return inputWithOptionsDriverFactory(args);
};

export { autoCompleteDriverFactory };
